<template>
    <div class="contact" v-bind="attrs">
        <div v-if="IsEditor" class="admin-control">
            <a v-if="IsAdmin" :href="EditPersonUrl + Id" target="_blank">
                <i class="fa fa-2x fa-pencil-square-o mx-1"></i>
            </a>
            <i class="fa fa-regular fa-2x fa-arrows-up-down-left-right drag-contact mx-1"></i>
            <i class="fa fa-2x fa-minus-circle text-danger mx-1" @click="$emit('remove')"></i>
        </div>

        <div class="contact-img" v-if="ShowImage">
            <img class="img-fluid rounded-circle" :src="ImageUrl" :alt="FullName" />
        </div>

        <div class="contact-body">
            <div class="contact-name">
                {{ FullName }}
            </div>

            <div class="contact-title" v-if="ShowTitle">{{ Title }}</div>

            <div class="contact-phone" v-if="ShowPhone">(P) {{ Phone }}</div>
            <div class="contact-phone" v-if="ShowAltPhone">(P) {{ AltPhone }}</div>
            <div class="contact-phone" v-if="ShowFax">(F) {{ Fax }}</div>
            <div class="contact-email" v-if="ShowEmail">
                <a :href="'mailto:' + Email"><i class="fas fa-envelope"></i> {{translate('Email me')}}</a>
            </div>
            <div class="contact-social" v-if="ShowBio || ShowTwitter || ShowLinkedIn">
                <a href="#" v-if="ShowBio" class="mx-1" @click.prevent="$emit('popmodal')">({{translate('Bio')}})</a>

                <a :href="TwitterUrl" target="_blank" v-if="ShowTwitter" class="mx-1" title="Twitter/X">
                    <i class="fa-brands fa-x-twitter"></i>
                </a>

                <a :href="LinkedInUrl" target="_blank" v-if="ShowLinkedIn" class="mx-1" title="LinkedIn">
                    <i class="fa fa-linkedin"></i>
                </a>
            </div>
        </div>
    </div>
</template>


<script setup>
    import { computed, inject, useAttrs } from 'vue';
    import { useWidgetConfig } from '../useWidgetConfig';
    import { useTranslations } from '../useTranslations';

    const IsEditor = inject('IsEditor')
    const IsAdmin = inject('IsAdmin')
    const EditPersonUrl = inject('EditPersonUrl')
    const Resources = inject('Resources');

    const attrs = useAttrs();

    defineOptions({
        inheritAttrs: false
    })

    const props = defineProps({
        Id: [String, Number],
        FullName: String,
        Email: String,
        Phone: String,
        AltPhone: String,
        Fax: String,
        Title: String,
        Department: String,
        ImageUrl: String,
        TwitterUrl: String,
        LinkedInUrl: String,
        Bio: Object,
        config: Object
    })


    const translate = useTranslations(Resources);

    const { configFlag } = useWidgetConfig(props.config);

    const ShowImage = configFlag('IncludeImage', () => props.ImageUrl)
    const ShowEmail = configFlag('IncludeEmail', () => props.Email)
    const ShowPhone = configFlag('IncludePhone', () => props.Phone)
    const ShowAltPhone = configFlag('IncludeAltPhone', () => props.AltPhone)
    const ShowFax = configFlag('IncludeFax', () => props.Fax)
    const ShowTitle = configFlag('IncludeTitle', () => props.Title)
    const ShowTwitter = configFlag('IncludeTwitter', () => props.TwitterUrl)
    const ShowLinkedIn = configFlag('IncludeLinkedIn', () => props.LinkedInUrl)
    const ShowBio = configFlag('IncludeBio', () =>
        !!props.Bio &&
        (!!props.Bio.Content || !!props.Bio.HeroImageUrl)
    )
</script>